import { useMediaQuery } from '@vueuse/core'

export const useResponsive = () => {
  const isMaxMd = useMediaQuery('(max-width: 768px)', { ssrWidth: 768 })
  const isMaxLg = useMediaQuery('(max-width: 1024px)', { ssrWidth: 1024 })
  const isMinLg = useMediaQuery('(min-width: 1024px)', { ssrWidth: 1024 })
  const isMin1440 = useMediaQuery('(min-width: 1440px)', { ssrWidth: 1440 })
  const isMinHD = useMediaQuery('(min-width: 1920px)', { ssrWidth: 1920 })

  return {
    isMaxMd,
    isMaxLg,
    isMinLg,
    isMin1440,
    isMinHD,
  }
}
